var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialNeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800195 17.0002C0.472195 17.0002 0.200195 16.7345 0.200195 16.4141V0.786242C0.200195 0.46587 0.472195 0.200195 0.800195 0.200195C1.1282 0.200195 1.4002 0.46587 1.4002 0.786242V16.4141C1.4002 16.7345 1.1282 17.0002 0.800195 17.0002Z",
    fill: "#636F7C",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63067 12.1999H0.792066C0.46851 12.1999 0.200195 11.9279 0.200195 11.5999C0.200195 11.2719 0.46851 10.9999 0.792066 10.9999H9.63067C10.4909 10.9999 10.8933 10.7679 10.9722 10.5679C11.0512 10.3679 10.9328 9.9199 10.3172 9.3039L9.37025 8.3439C8.98356 7.9999 8.74681 7.4799 8.72313 6.9039C8.69946 6.2959 8.93621 5.6959 9.37025 5.2559L10.3172 4.2959C10.9012 3.7039 11.0827 3.2239 10.9959 3.0159C10.9091 2.8079 10.4593 2.5999 9.63067 2.5999H0.792066C0.460618 2.5999 0.200195 2.3279 0.200195 1.9999C0.200195 1.6719 0.46851 1.3999 0.792066 1.3999H9.63067C11.3589 1.3999 11.9113 2.1279 12.0929 2.5599C12.2665 2.9919 12.3848 3.9039 11.1538 5.1519L10.2068 6.1119C10.0095 6.3119 9.89898 6.5919 9.90688 6.8719C9.91477 7.1119 10.0095 7.3279 10.1752 7.4799L11.1538 8.4639C12.3612 9.6879 12.2428 10.5999 12.0692 11.0399C11.8877 11.4639 11.3274 12.1999 9.63067 12.1999Z",
    fill: "#636F7C",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialNeeds);
export default __webpack_public_path__ + "static/media/SpecialNeeds.95eddbc5cbdf5f24f4b83855947494b0.svg";
export { ForwardRef as ReactComponent };